import { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Divider,
  Spinner,
  Box,
} from '@chakra-ui/react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { GET_BRAINTREE_CLIENT_TOKEN_ENDPOINT } from '../../../_actions/endpoints';
import { handleHTTPError } from '../../../_actions/errorHandlerActions';

import TldrPaymentSummary from '../TldrPaymentSummary';

import { useTranslation } from 'react-i18next';
import { PaymentSources } from 'apps/simplified-web/src/_actions/types';

const TldrPaymentSummaryModal = ({
  onClose,
  selectedPlan,
  cartItems,
  handleStripeCheckout,
  isLoading,
}) => {
  const { t } = useTranslation(['billing']);

  const [clientToken, setClientToken] = useState(null);

  const [isPaypalLoading, setIsPaypalLoading] = useState(false);


  const subscription = useSelector((state) => state.subscription);
  let isShopify = subscription?.subscribedPlan?.source === PaymentSources.SHOPIFY;

  useEffect(() => {
    if(!isShopify)
    axios
      .get(GET_BRAINTREE_CLIENT_TOKEN_ENDPOINT)
      .then((res) => {
        setClientToken(res.data.token);
      })
      .catch((error) => handleHTTPError(error));
  }, [isShopify]);

  return (
    <Modal
      size="sm"
      onClose={onClose}
      isOpen
      closeOnOverlayClick={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent minH="sm">
        <ModalHeader fontSize={'md'} fontWeight="500">
          {t('braintree_modal.title', { name: selectedPlan?.product?.name })}
        </ModalHeader>
        <Divider mt="0" />
        {!clientToken && !isPaypalLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            h="full"
            alignItems="center"
          >
            <Spinner size="xl" color="brand.primary" textAlign="center" />
          </Box>
        ) : (
          <ModalBody>
            <TldrPaymentSummary
              setIsPaypalLoading={setIsPaypalLoading}
              selectedPlan={selectedPlan}
              cartItems={cartItems}
              handleStripeCheckout={handleStripeCheckout}
              isLoading={isLoading}
              clientToken={clientToken}
            />
          </ModalBody>
        )}
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};

TldrPaymentSummaryModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  cartItems: PropTypes.object.isRequired,
  handleStripeCheckout: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default TldrPaymentSummaryModal;
